import React from 'react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogTitle,
} from '@onward-delivery/design';

const DeleteAutomationDialog = ({ automation, onOpenChange, onConfirm, deleting }) => (
    <AlertDialog open={!!automation} onOpenChange={onOpenChange}>
        <AlertDialogContent>
            <AlertDialogTitle className="text-lg font-semibold">Delete automation?</AlertDialogTitle>
            <AlertDialogDescription className="text-sm text-muted">
                This deletes <span className="!font-mono">{automation?.url}</span> and its Cloud Scheduler job. It will
                stop running immediately.
            </AlertDialogDescription>
            <div className="mt-4 flex justify-end gap-2">
                <AlertDialogCancel>Cancel</AlertDialogCancel>
                <AlertDialogAction
                    destructive
                    disabled={deleting}
                    onClick={(event) => {
                        event.preventDefault();
                        onConfirm(automation);
                    }}
                >
                    Delete
                </AlertDialogAction>
            </div>
        </AlertDialogContent>
    </AlertDialog>
);

export default DeleteAutomationDialog;
